import { render, staticRenderFns } from "./HomeFeaturesWestudy.vue?vue&type=template&id=3ee7502a&scoped=true&"
import script from "./HomeFeaturesWestudy.vue?vue&type=script&lang=js&"
export * from "./HomeFeaturesWestudy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee7502a",
  null
  
)

export default component.exports